var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Importing components
import { CurrentChapterIndicator } from '../chapters/current-chapter-indicator';
// Importing hooks
import { useDuration } from '../../../hooks/use-duration';
import { useShallow } from 'zustand/react/shallow';
// Importing store
import { useMediaStore } from '../../../store/media.store';
import { usePlayerStore } from '../../../store/player.store';
import { tooltipClasses } from '@mui/material/Tooltip';
// Importing 3rd party components
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom';
// Importing 3rd party dependencies
import { styled } from '@mui/material/styles';
// ----------------------------------------------------------------------
export const ProgressBarPreview = (props) => {
    const { children } = props;
    return (_jsx(ProgressBarPreviewWrapper, { title: _jsx(ProgressBarPreviewElements, {}), children: children }));
};
// ----------------------------------------------------------------------
const ProgressBarPreviewElements = () => {
    // Adding hooks
    const { formatDuration } = useDuration();
    const { convertPosition } = useDuration();
    // Adding data handler
    const { chapter, duration, played, sliderHoverPosition } = usePlayerStore(useShallow((state) => ({
        chapter: state.chapter,
        duration: state.duration,
        played: state.played,
        sliderHoverPosition: state.sliderHoverPosition,
    })));
    // Initializing media store
    const { media } = useMediaStore(useShallow((state) => ({
        media: state.media,
    })));
    // Converting slider hover position to thumbnail position
    // We use this to display the thumbnail corresponding to the current mouse position within the slider
    const thumbnailId = convertPosition(duration, sliderHoverPosition);
    const thumbnailDuration = duration * sliderHoverPosition;
    const thumbnailDurationValue = thumbnailDuration > 0 ? thumbnailDuration : 0;
    const uploadPath = (media === null || media === void 0 ? void 0 : media.url) ? media.url.substring(0, media.url.lastIndexOf('/')) : undefined;
    // Getting current chapter from hover position
    const currentChapter = media === null || media === void 0 ? void 0 : media.chapters.find((chapter) => thumbnailDuration <= chapter.to / 1000);
    return (_jsxs(Stack, { alignItems: 'center', flexDirection: 'column', children: [media && media.transcoded && uploadPath && (_jsx(Box, { component: 'img', src: `${uploadPath}/thumbnails/thumbnail-${thumbnailId}.jpg`, sx: {
                    border: 2,
                    borderStyle: 'solid',
                    borderRadius: 1,
                    borderColor: 'white',
                } })), currentChapter && (_jsx(CurrentChapterIndicator, { chapter: currentChapter, containerStyle: { mt: 1 }, fontStyle: { color: 'white', fontSize: 14 } })), _jsx(Typography, { color: "white", variant: "caption", sx: { fontWeight: 'bold' }, children: formatDuration(thumbnailDurationValue) })] }));
};
// ----------------------------------------------------------------------
const ProgressBarPreviewWrapper = styled((_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx(Tooltip, Object.assign({}, props, { classes: { popper: className }, followCursor: true, placement: "top", slots: {
            transition: Zoom,
        } })));
})(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'transparent',
        padding: 0,
    },
}));
